import React from "react";
import styles from "./parts.module.css";

type Props = {
  isCancelled?: boolean;
  isLoading?: boolean;
  isRxBag?: boolean;
};

const BoxItemOverlays = ({ isCancelled, isLoading, isRxBag }: Props) => {
  return (
    <>
      {isCancelled && <span className={styles["box-item-card--cancelled__banner"]} />}
      {isLoading && <div className={styles["loader"]} />}
      {isRxBag && <div className={styles["ribbon"]}>Receptpåse</div>}
    </>
  );
};

export default BoxItemOverlays;
